(function ($) {
    $(document).ready(function () {
        if ($('.key-focus-detail').length) {
            $('.key-focus-detail .slider-wrapper').on('init afterChange', function (e, slick) {
                let currentSlick = $('.slick-current.slick-active', slick.$slideTrack);
                let prevName = currentSlick.prev().data('slide-name');
                let nextName = currentSlick.next().data('slide-name');

                slick.$prevArrow.text(prevName);
                slick.$nextArrow.text(nextName);
                if ($('.slick-prev').hasClass('slick-disabled')) {
                    $('.slick-prev.slick-disabled').text('');
                    $('.slick-prev.slick-disabled').append('<a href="/research/key-focus-areas">All Key Focus Area</a>');
                }

                if ($(this).find('.slick-next').hasClass('slick-disabled')) {
                    if (!$('.slick-next.slick-disabled').hasClass('list-link')) {
                        $('.slick-next.slick-disabled').text('');
                        $('.slick-next.slick-disabled').append('<a href="/research/key-focus-areas">All Key Focus Area</a>');
                        $('.slick-next.slick-disabled').addClass('list-link');
                    } else {
                        return false;
                    }
                }
                $('html, body').animate({
                    scrollTop: "0px"
                }, 800);

                // For focus-carousel-para: set uniform height on init
                if ($('.key-focus-detail').hasClass('focus-carousel-para')) {
                    var $activeSlide = currentSlick;
                    var $wrapper = $activeSlide.find('.wrapper');
                    var slideContentHeight = $wrapper.outerHeight(true) + 30; // content + cushion

                    // Force all slides to match the active one's height for consistent vertical math
                    $(slick.$slides).css('height', slideContentHeight + 'px');
                    slick.$list.css('height', slideContentHeight + 'px');

                    setTimeout(function () {
                        slick.setPosition();
                    }, 100);
                }
            });

            // For focus-carousel-para: adjust heights before each manual/auto slide change
            if ($('.key-focus-detail').hasClass('focus-carousel-para')) {
                $('.key-focus-detail .slider-wrapper').on('beforeChange', function (e, slick, currentSlide, nextSlide) {
                    var $nextSlide = $(slick.$slides[nextSlide]);
                    var $wrapper = $nextSlide.find('.wrapper');

                    // Temporarily ensure next slide is measurable
                    var prevStyle = $nextSlide.attr('style') || '';
                    $nextSlide.css({ display: 'block', visibility: 'hidden', height: 'auto', position: 'absolute' });
                    var nextHeight = $wrapper.outerHeight(true) + 120;
                    $nextSlide.attr('style', prevStyle); // Restore

                    // Set ALL slides to this new height so translation math (index * height) stays correct
                    $(slick.$slides).css('height', nextHeight + 'px');
                    slick.$list.css('height', nextHeight + 'px');

                    // Trigger Slick repositioning immediately
                    slick.setPosition();
                });
            }

            var adaptiveHeight = $('.key-focus-detail').hasClass('focus-carousel-para');
            $('.key-focus-detail .slider-wrapper').not('.slick-initialized').slick({
                autoplay: false,
                vertical: true,
                infinite: false,
                verticalSwiping: false,
                adaptiveHeight: adaptiveHeight,
                slidesToScroll: 1,
                slidesToShow: 1,
                dots: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            dots: false,
                        }
                    },
                ]
            });

            if ($('.key-focus-detail .slider-wrapper .slick-arrow').hasClass('slick-disabled')) {
                if (!$('.slick-arrow.slick-disabled').hasClass('list-link')) {
                    $('.slick-arrow.slick-disabled').text('');
                    $('.slick-arrow.slick-disabled').append('<a href="/research/key-focus-areas">All Key Focus Area</a>');
                    $('.slick-arrow.slick-disabled').addClass('list-link');
                } else {
                    return false;
                }
            }

            $('.key-focus-detail .slider-wrapper .slide-item .wrapper .content-wrap p').dotdotdot({
                height: 200,
                fallbackToLetter: true,
                watch: true,
            });

            $('<a href="/research/key-focus-areas" class="see-all"><span>See All</span></a>').insertBefore('.key-focus-detail .slider-wrapper .slide-item .bg-img');
        }
    });
    $(window).on('load', function () {
        if ($('.key-focus-detail').length) {
            var url = window.location.href;
            var last = url.substring(url.lastIndexOf("/") + 1, url.length);
            var replace = last.replace("%E2%80%99", "’");
            var slide = $(".key-focus-detail .slider-wrapper .slide-item[data-id='/about/keyfocus/" + replace + "']");
            var slideIndex = slide.data("slick-index");
            $(".key-focus-detail .slider-wrapper").slick('slickGoTo', slideIndex);


            // var arr = [];
            // var data_id, arr_val;
            // $('.key-focus-detail .slider-wrapper .slide-item').each(function () {
            //     data_id = $(this).attr('data-id');
            //     arr.push(data_id);
            // });
            // $.each(arr, function (index, value) {
            //
            //     arr_val = value;
            //     if (last === arr_val) {
            //
            //         var $slide = $(".key-focus-detail .slider-wrapper .slide-item[data-id=" + last + "]");
            //         var slideIndex = $slide.data("slick-index");
            //
            //         $(".key-focus-detail .slider-wrapper").slick('slickGoTo', slideIndex);
            //     }
            // });
            $('.key-focus-detail .slider-wrapper .slick-dots').wrap("<div class='dots-wrap'></div>");
            if ($('.key-focus-detail .slider-wrapper .slick-dots li').length > 7) {
                $('.key-focus-detail .slider-wrapper .slick-dots li:gt(6)').hide();
                $('.key-focus-detail .slider-wrapper .dots-wrap').append('<span class="arrow"></span>');
                $('.key-focus-detail .slider-wrapper .dots-wrap').append('<div class="arrow-up"></div>');
            }
            $('.key-focus-detail .slider-wrapper .dots-wrap .arrow').on('click', function () {
                $('.key-focus-detail .slider-wrapper .slick-dots li').animate({ top: "-70px" });
                $('.key-focus-detail .slider-wrapper .slick-dots li').show();
                $(this).fadeOut();
                $('.key-focus-detail .slider-wrapper .dots-wrap .arrow-up').fadeIn();
            });
            $('.key-focus-detail .slider-wrapper .dots-wrap .arrow-up').on('click', function () {
                $('.key-focus-detail .slider-wrapper .slick-dots li').animate({ top: "0" });
                $('.key-focus-detail .slider-wrapper .slick-dots li:gt(6)').hide();
                $(this).fadeOut();
                $('.key-focus-detail .slider-wrapper .dots-wrap .arrow').fadeIn();
            });
            // $('.key-focus-detail .slide-item .wrapper .research-col ul li a').dotdotdot({
            //     height: 55,
            //     fallbackToLetter: true,
            //     watch: true,
            // });
            $('.key-focus-detail .slide-item .wrapper .research-col ul li a').html(function () {
                // separate the text by spaces
                var text = $(this).text().split(' ');
                // drop the last word and store it in a variable
                var last = text.pop();
                // join the text back and if it has more than 1 word add the span tag
                // to the last word
                return text.join(" ") + (' <span class="last">' + last + '</span>');
            });
        }
    });

})(jQuery);